<template>
  <div class="layout__container">
    <div class="basket wrapper__content-medium" id="app">
      <notifications-bar></notifications-bar>
      <div v-if="!basketEmpty">
        <div class="basket__section">
          <div class="basket__row basket__header">
            <div class="basket__product-title">
              <p v-html="locale.item"></p>
            </div>
            <div class="basket__product-price">
              <p>{{locale.price}} <span>({{locale.ex_vat}})</span></p>
            </div>
            <div class="basket__product-quantity">
              <p v-html="locale.quantity"></p>
            </div>
            <div class="basket__product-total">
              <p>{{locale.line_total}} <span>({{locale.ex_vat}})</span></p>
            </div>
            <div class="basket__product-remove">
              <p v-html="locale.remove"></p>
            </div>
          </div>
          <basket-product
            v-for="basket_product in basketProducts"
            :basket_product="basket_product"
            :key="basket_product.id">
          </basket-product>
          <div class="basket__row">
            <div class="basket__row-name">
              {{locale.sub_total}}
            </div>
            <div class="basket__row-value" v-html="formattedSubTotal"></div>
          </div>
          <div class="basket__row">
            <div class="basket__row-name">
              {{locale.delivery}}
            </div>
            <div class="basket__row-value" v-html="formattedTotalDelivery"></div>
          </div>
          <div class="basket__row">
            <div class="basket__row-name">
              {{locale.discounts}}
            </div>
          </div>
          <div class="discounts__wrapper" v-if="basketHasDiscounts">
            <div
              class="basket__row basket__row-discounts"
              v-for="discount in discounts"
              :key="discount.code">
              <div class="basket__row-name">
                {{ discount.description }}
                <span v-if="discount.expired">
                  {{ locale.discount_expired }}
                </span>
              </div>
              <div class="basket__row-value">
                {{ formatCurrency(discount.discount) }}
              </div>
            </div>
          </div>
          <div class="basket__row">
            <div class="basket__row-name">
              {{locale.total_discount}}
            </div>
            <div class="basket__row-value" v-html="formattedTotalDiscount"></div>
          </div>
          <div class="basket__row">
            <div class="basket__row-name">
              {{locale.vat}}
            </div>
            <div class="basket__row-value" v-html="formattedTotalVat"></div>
          </div>
          <div class="basket__row">
            <div class="basket__row-name basket__sub-total">
              {{locale.total}}
            </div>
            <div class="basket__row-value basket__sub-total" v-html="formattedGrandTotal"></div>
          </div>
        </div>
        <div class="basket__section basket__discount-add">
          <discount-code-form></discount-code-form>
        </div>
        <div class="basket__actions panel panel--padding-top-none panel--padding-bottom-none">
          <button class="btn btn--secondary btn--rounded"
                  v-html="locale.continue_shopping"></button>
          <a class="btn btn--brand btn--rounded" v-html="locale.checkout" href="/shop/checkout"></a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import numeral from 'numeral';
import { mapGetters } from 'vuex';

import BasketProduct from './basket_product.vue';
import DiscountCodeForm from './discount_code_form.vue';
import NotificationsBar from './notifications_bar.vue';

export default {
  data() {
    return {
      basket: {
        locale: {},
        basket_products: [],
        totals: {
          sub_total: 0,
          delivery: 0,
          total_discount: 0,
          total_vat: 0,
          grand_total: 0,
          discounts: [],
        },
      },
    };
  },
  components: {
    BasketProduct,
    DiscountCodeForm,
    NotificationsBar,
  },
  methods: {
    fetchBasket() {
      this.$store.dispatch('load');
    },
    formatCurrency(number) {
      return `${this.locale.currency_symbol}${numeral(number).format(this.locale.currency_mask)}`;
    },
  },
  computed: {
    ...mapGetters([
      'basketEmpty',
      'basketProducts',
      'subTotal',
      'totalDelivery',
      'totalDiscount',
      'totalVat',
      'grandTotal',
      'discounts',
      'locale',
    ]),
    formattedSubTotal() { return this.formatCurrency(this.subTotal); },
    formattedTotalDelivery() { return this.formatCurrency(this.totalDelivery); },
    formattedTotalDiscount() { return this.formatCurrency(this.totalDiscount); },
    formattedTotalVat() { return this.formatCurrency(this.totalVat); },
    formattedGrandTotal() { return this.formatCurrency(this.grandTotal); },
    basketHasDiscounts() { return this.discounts.length > 0; },
  },
  created() {
    this.fetchBasket();
  },
};
</script>
